<!-- eslint-disable vue/no-restricted-html-elements -->
<template>
  <div>
    <div
      class="product-gallery-carousel product-gallery-carousel--gallery"
    >
      <button
        v-for="(mediaItem, index) of filteredMedia"
        :key="mediaItem.id"
        type="button"
        class="product-gallery-thumbs__button"
        :style="{ opacity: index === currentIndex ? '1' : '0.2' }"
        :aria-label="`Image ${index + 1} of ${filteredMedia.length}`"
      >
        <div
          class="product-gallery-carousel__image-container"
          :class="{
            'has-custom-crop': index === 0 && hasCustomCrop,
            [$class('loading')]: loading,
          }"
        >
          <responsive-image
            class="product-gallery-carousel__image"
            :image="mediaItem.previewImage || mediaItem.image || mediaItem"
            :ratio="ratio"
            :sizes="sizes"
            tabindex="-1"
            @click.prevent="handleImageClick(mediaItem.index)"
          />

          <icon-play
            v-if="mediaItem.mediaType === 'video'"
            class="product-gallery-carousel__play-icon"
          />
        </div>
      </button>
    </div>
  </div>
</template>

<script>

/**
 * Vue: Product gallery thumbnails (product-gallery-thumbs)
 * -----------------------------------------------------------------------------
 * Thumbnail navigation component for product image carousel
 *
 * @param {Number} currentIndex - Current carousel index.
 * @param {Boolean} [customCrop] - Add custom crop class if applicable.
 * @param {Array} filteredMedia - Filtered media to render.
 * @param {Boolean} [loading] - Loading state.
 * @param {Object} product - Local product object.
 * @param {String} ratio - Ratio attribute.
 * @param {String} sizes - Sizes attribute.
 *
 * @emits updateCurrentIndex -  Emit update current carousel index event.
 *
 */

import ResponsiveImage from '~global/images/responsive-image'

import IconPlay from '~icons/general/play.svg'

export default {
  name: 'ProductGalleryThumbs',

  components: {
    IconPlay,
    ResponsiveImage,
  },

  props: {
    currentIndex: {
      type: Number,
      default: 0,
    },
    customCrop: {
      type: Boolean,
      default: false,
    },
    filteredMedia: {
      type: Array,
      default: () => [],
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    product: {
      type: [Boolean, Object],
      default: () => ({
        handle: '',
        images: [],
        media: [],
        title: '',
      }),
    },
    ratio: {
      type: [Boolean, String],
      default: false,
    },
    sizes: {
      type: String,
      default: '102px',
    },
  },

  emits: {
    'update-current-index': (payload) => typeof payload === 'number',
  },

  data() {
    return {
      localSlideIndex: 0,
    }
  },

  computed: {

    /**
     * Compute if the image should use custom crop due to product being in
     * specified collection.
     * @returns {Boolean}
     */
    hasCustomCrop() {
      if (!this.customCrop) {
        return false
      }

      return this.product.collections.some((handle) => {
        return this.$variable('settings.product.customCropCollections').includes(handle)
      })
    },
  },

  methods: {

    /**
     * Handle image click.
     * @param {Number} index - Clicked media index.
     */
    handleImageClick(index) {
      this.$emit('update-current-index', index)
    },
  },
}
</script>

<style lang="scss">
@import './product-gallery-thumbs';
</style>
